onReady(($) => {
    $('.feature')
        .each((index, module) => {
            let $module = $(module)
            $('.image-carousel', $module)
                .not('.isOnPage')
                .slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    prevArrow: $(".slick-prev", $module),
                    nextArrow: $(".slick-next", $module),
                    fade: false,
                });
        });

    const wistiaVideoFeatureModules = $('.feature .wistia_embed')
    if (wistiaVideoFeatureModules.length === 0) {
        return
    }

    const loadVideo = () => {
        $(window)
            .off('scroll', loadVideo)

        wistiaVideoFeatureModules.each(
            (i, videoModule) => $('.wistia_embed', videoModule)
                .each((i, wistiaEmbed) => loadWistiaMedia(wistiaEmbed.dataset.videoId)),
        )

        loadWistiaLibrary()
    }
    $(window)
        .on('scroll', loadVideo)

    // Load if user has already scrolled
    if (window.scrollY > 0) {
        loadVideo()
    }
});
